import { CommonModule } from '@angular/common'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { EventService } from '../../services/event.service'
import { StateService } from '../../services/state.service'
import { RouterService } from '../../services/router.service'
import { StatusUnavailableError } from '../../utils/status-unavailable-error'

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslateModule],
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit, OnDestroy {
  stateErrorSubscription?: Subscription
  eventSubscription?: Subscription

  error?: any
  titleKey = 'PAGES.ERROR.AN_ERROR_OCCURRED'
  messageKey = 'PAGES.ERROR.CONTACT_SUPPORT'
  showError = false

  constructor(
    private eventService: EventService,
    private routerService: RouterService,
    private stateService: StateService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.registerStateErrorListener()
    this.registerEventListener()
  }

  ngOnDestroy(): void {
    this.stateErrorSubscription?.unsubscribe()
    this.eventSubscription?.unsubscribe()
  }

  registerStateErrorListener(): void {
    this.stateErrorSubscription = this.stateService.error$.subscribe(error => {
      if (error?.rejection) {
        error = error.rejection
      }
      this.error = error
      const isStatusUnavailable = error instanceof StatusUnavailableError
      this.titleKey = isStatusUnavailable ? 'PAGES.ERROR.STATUS_UNAVAILABLE_TITLE' : 'PAGES.ERROR.AN_ERROR_OCCURRED'
      this.messageKey = isStatusUnavailable ? 'PAGES.ERROR.STATUS_UNAVAILABLE_MESSAGE' : 'PAGES.ERROR.CONTACT_SUPPORT'
    })
  }

  registerEventListener(): void {
    this.eventSubscription = this.eventService.keyDown.subscribe((key: string) => {
      switch (key) {
        case 'e':
        case 'COL-BLUE':
          this.showError = true
          break
        default:
          break
      }
    })
  }

  restartApp(): void {
    this.routerService.restartApp()
  }
}
